import React from 'react';

import MenuSectionHeading from 'components/menu-section-heading';
import useEffectOnce from 'hooks/use-effect-once';
import { useOfferHeader } from 'hooks/use-offer-header';
import { Section } from 'pages/home/styled';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useOffersContext } from 'state/offers';

import Offers from './offers';

const OffersSection = () => {
  const offerHeader = useOfferHeader();
  const { loading, offers: filteredOffers, refreshOffers } = useOffersContext();
  const showOffersOnHomepage = useFlag(LaunchDarklyFlag.ENABLE_OLD_OFFERS_HOMEPAGE_SECTION);

  /**
   * Reload offers/coupons if OffersContext isn't loading that right now
   */
  useEffectOnce(() => {
    if (!loading && showOffersOnHomepage && !filteredOffers.length) {
      refreshOffers();
    }
  });

  // fail fast
  if (!showOffersOnHomepage) {
    return null;
  }

  const haveOffers = filteredOffers.length > 0;

  // If have no offers then just return
  if (!haveOffers) {
    return null;
  }

  return (
    <Section data-testid="offers-homepage-section">
      <MenuSectionHeading as="h2">{offerHeader}</MenuSectionHeading>
      <Offers />
    </Section>
  );
};

export default OffersSection;
